<template lang="pug">
  ul.reach-legend
    li.guaranteed {{ $t('pos.offer.guaranteed') }}
    li.not-reached {{ $t('pos.offer.not-reached') }}
</template>

<script>
export default {};
</script>



// WEBPACK FOOTER //
// SvgLegend.vue?d6418c6c